export const setDashboardStats = {
  SET_DASHBOARD_STATS(state, payload) {
    state.dashboardStats = payload;
  }
};
